import {addDays, isSameDay, set, startOfDay} from 'date-fns';
import {fromZonedTime, toZonedTime} from 'date-fns-tz';

const SAMARA_TZ = 'Europe/Moscow';


export const isAllowedWeekday = (date: Date) => {
    const day = date.getDay();

    const yyyy = date.getFullYear();
    const mm = date.getMonth(); // 0-based
    const dd = date.getDate();

    // --- Запрещённый диапазон: 31.12.2025 – 04.01.2026 ---
    const from = new Date(2025, 11, 31); // 31.12.2025
    const to = new Date(2026, 0, 4);     // 04.01.2026

    if (date >= from && date <= to) {
        return false;
    }

    // --- Явно запрещённые даты ---
    const forbiddenDates = [
        new Date(2025, 11, 20), // 20.12.2025
        new Date(2025, 11, 27), // 27.12.2025
    ];

    if (
        forbiddenDates.some(
            d =>
                d.getFullYear() === yyyy &&
                d.getMonth() === mm &&
                d.getDate() === dd
        )
    ) {
        return false;
    }

    // --- Явно разрешённая дата (исключение) ---
    if (yyyy === 2025 && mm === 11 && dd === 29) {
        return true; // 29.12.2025 (понедельник)
    }

    // --- Базовое правило по дням недели ---
    return day !== 0 && day !== 1 && day !== 4 && day !== 6;
};


export const isAllowedWeekdayWithoutSunday = (date: Date) => {
    // Запрещённый диапазон: 31.12.2025 – 04.01.2026
    const from = new Date(2025, 11, 31);
    const to = new Date(2026, 0, 4);

    if (date >= from && date <= to) {
        return false;
    }

    // Запрет только на воскресенье
    return true;
};

export const isTomorrowByTimeZone = (selectedDate: Date, now: Date = new Date()) => {
    const nowSamara = toZonedTime(now, SAMARA_TZ);
    const todaySamara = startOfDay(nowSamara);
    const tomorrowSamara = addDays(todaySamara, 1);

    const selectedSamara = toZonedTime(selectedDate, SAMARA_TZ);
    return isSameDay(selectedSamara, tomorrowSamara);
};

export const isAfterCutoff22Today = (now: Date = new Date()) => {
    const nowSamara = toZonedTime(now, SAMARA_TZ);
    const todaySamara = startOfDay(nowSamara);

    const cutoffSamaraWallClock = set(todaySamara, {
        hours: 22,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    });

    const cutoffUtc = fromZonedTime(cutoffSamaraWallClock, SAMARA_TZ);
    return now.getTime() > cutoffUtc.getTime();
};

export const isAfterCutoff22 = (acceptanceDate: Date, now: Date = new Date()) => {
    const wallClockCutoff = set(addDays(acceptanceDate, -1), {
        hours: 22,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    });
    const cutoffUtc = fromZonedTime(wallClockCutoff, SAMARA_TZ);
    return now.getTime() > cutoffUtc.getTime();
};

export const isFakeAcceptanceDate = (d: Date) => {
    const s = d?.toString?.() ?? '';
    return s === '2060-01-01';
};
